<template>
  <div data-slot="leadgen-form-leads-filters" :class="stacked ? 'flex flex-col gap-4' : 'contents'">
    <div v-for="filter in filters" :key="filter.name" :class="stacked ? 'flex flex-col gap-1.5' : 'contents'">
      <ui-label v-if="stacked">{{ filter.label }}</ui-label>
      <ui-select :model-value="filter.value" @update:model-value="(value) => $emit('change', filter.name, value)">
        <ui-select-trigger :class="stacked ? 'w-full' : [ 'min-w-0 flex-1', filter.triggerClass ]" :aria-label="filter.label">
          <ui-select-value />
        </ui-select-trigger>
        <ui-select-content>
          <template v-for="option in filter.options">
            <ui-select-separator v-if="option.separator" :key="'separator--' + option.value" />
            <ui-select-item v-else :key="option.value" :value="option.value">
              {{ option.label }}
            </ui-select-item>
          </template>
        </ui-select-content>
      </ui-select>
    </div>
  </div>
</template>

<script>
/**
 * The status / assignee / campaign selects of the lead list: inline in the toolbar, or stacked
 * with labels (the filter sheet on phones).
 */
export default {
  name: 'LeadgenFormLeadsFilters',
  props: {
    // [{ name, label, value, triggerClass, options: [{ value, label, separator? }] }]
    filters: {
      type: Array,
      required: true,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'change' ],
};
</script>
